import { useMatches } from 'react-router';

import type { PreloadImage } from '@shared/types/backend/page-route/details-page-route';
import type { Optional } from '@shared/types/utils';
import type { GeneratedHrefLangItems } from '@skyscanner/href-lang-generation/dist/types';

export type RouteData = {
  pageData: {
    preloadImages: PreloadImage[];
    hrefLangLinks: GeneratedHrefLangItems;
  };
};

export function DynamicLinks() {
  const matches = useMatches();

  const routeData = matches.find((match) => {
    const data = (match.data as RouteData)?.pageData;
    return data?.preloadImages?.length || data?.hrefLangLinks?.length;
  })?.data as Optional<RouteData>;

  const pageData = routeData?.pageData;

  if (!pageData) return null;

  return (
    <>
      {pageData.preloadImages?.map((image) => (
        <link
          key={image.href}
          rel="preload"
          as="image"
          href={image.href}
          {...{ imageSrcSet: image.imagesrcset }}
        />
      ))}

      {pageData.hrefLangLinks?.map((link) => (
        <link
          key={`${link.hrefLangName}-${link.url}`}
          rel="alternate"
          hrefLang={link.hrefLangName}
          href={link.url}
        />
      ))}
    </>
  );
}
